// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KL-YR","top":"styles_top__2BVkR"};